<template>
  <v-footer class="pa-0 ma-0 full-width">
    <h2 class="titulos-secciones">Contacto</h2>
    <v-col cols="12" class="contacto" >
      <v-row >
        <v-col
          cols="12"
          sm="5"
          md="4"
          lg="2"
          class="pl-0 pl-sm-10 pl-md-10 pl-lg-10 pt-7"
        >
          <h3>Bogotá</h3>
          <p>Calle 18 # 25 - 55<br />Paloquemao</p>

          <h3>Contacto Bogotá</h3>
          <p>(+57 1) 277 02 14 - 277 02 18</p>
        </v-col>
        <v-col
          cols="12"
          sm="5"
          md="4"
          lg="3"
          class="pt-0 pt-sm-7 pt-md-7 pt-lg-7 mt-n2 mt-sm-0 mt-md-0 mt-lg-0"
        >
          <h3>Cali</h3>
          <p>Carrera 1 # 50 - 198 <br />Evaristo García</p>

          <h3>Contacto Cali</h3>
          <p>(+57 2) 4472195 - 446 0262- 447 56 85</p>
        </v-col>
        <v-col cols="12" class="pl-10 mt-n5 mb-5">
          <h3>Ventas</h3>
          <p>ventas@colimportados.com</p>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-row style="background-color: #575756" class="redes-logos">
      <v-col cols="12" sm="6" md="3" lg="2" class="d-flex justify-center">
        <v-img
          contain
          class="logo-colimportados"
          src="@/assets/images/logo-colimportados-blanco.svg"
          alt="logo colimportados"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="5" class="texto-copyright">
        Copyright © 2010-2024 Colimportados. Todos los derechos reservados.
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="3"
        lg="3"
        class="d-flex pl-6 pl-sm-0 justify-start justify-sm-end justify-md-start justify-lg-center"
      >
        <div
          small
          style="
            cursor: pointer;
            height: 50px;
            width: 50px;
            border-radius: 50%;
            background-color: #fbb03b;
          "
          class="d-flex align-center justify-center"
        >
          <v-icon large color="black">mdi-email</v-icon>
        </div>

        <p class="textos-redes">informacion@colimportados.com</p>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="2"
        lg="2"
        class="d-flex pl-6 pl-sm-0 justify-start justify-sm-center justify-md-start justify-lg-start"
      >
        <div
          small
          style="
            cursor: pointer;
            height: 50px;
            width: 50px;
            border-radius: 50%;
            background-color: #fbb03b;
          "
          class="d-flex align-center justify-center"
        >
          <v-icon large color="black">mdi-instagram</v-icon>
        </div>

        <p class="textos-redes red-social" style="cursor: pointer;">@Colimportados</p>
      </v-col>
    </v-row> 
    </v-col>
   
  </v-footer>
</template>

<script>
export default {};
</script>

<style scoped>

footer{
  width: 100%;
}
.titulos-secciones {
  width: 100%;
  padding: 15px 0;
  color: white;
  font-size: 1.5rem;
  text-align: center;
  background-color: #005d95;
  font-weight: 800;
}

h3 {
  font-size: 1.2rem;
}
p {
  font-size: 1rem;
}

.contacto {
 
  background: url("@/assets/images/footer.jpg") no-repeat;
}

.logo-colimportados {
  max-height: 60px;
}

.texto-copyright {
  color: white;
  padding: 30px 0px;
  text-align: center;
  font-size: 0.7rem;
}

.textos-redes {
  font-size: 0.8rem;
  padding-top: 13px;
  padding-left: 7px;
  color: white;
}

.red-social{
  cursor: pointer;
}

.red-social:hover{
  color: black;
}

@media (max-width: 600px) {

  .titulos-secciones{
    font-size: 1.2rem;
  }

  h3{
    font-size: 1rem;
  }

  p{
    font-size: 0.9rem;
  }
  .contacto {
    background: none;
    text-align: center;
  }

  .texto-copyright {
    text-align: center;
  }
}
</style>
